<img [src]="value || 'assets/images/profile.png'" #profilePhoto width="220">
<dx-button
  stylingMode="text"
  text="Changer"
  type="normal"
  width="100%"
  (onClick)="changeProfilePhoto($event)">
</dx-button>
<input class="hidden" (change)="onProfilePhotoUpload($event)" type="file" accept="image/*"
       #profilePhotoBtn>
